<template>
  <component
    :is="group ? TransitionGroup : Transition"
    enter-active-class="transition duration-500 ease-in-out"
    leave-active-class="transition duration-500 ease-in-out"
    :enter-from-class="enterFrom"
    :enter-to-class="enterTo"
    :leave-from-class="leaveFrom"
    :leave-to-class="leaveTo"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import { Transition, TransitionGroup } from 'vue';

import type { SlideProps } from '~/components/transitions/types';

let enterFrom = '';
let enterTo = '';
let leaveFrom = '';
let leaveTo = '';

const props = withDefaults(defineProps<SlideProps>(), { group: false });

onBeforeMount(() => {
  switch (props.direction) {
    case 'bottom':
      enterFrom = '-translate-y-full';
      enterTo = 'translate-y-0';
      leaveFrom = 'translate-y-0';
      leaveTo = '-translate-y-full';
      break;
    case 'left':
      enterFrom = 'translate-x-full';
      enterTo = '-translate-x-0';
      leaveFrom = '-translate-x-0';
      leaveTo = 'translate-x-full';
      break;
    case 'right':
      enterFrom = '-translate-x-full';
      enterTo = 'translate-x-0';
      leaveFrom = 'translate-x-0';
      leaveTo = '-translate-x-full';
      break;
    case 'top':
      enterFrom = 'translate-y-full';
      enterTo = 'translate-y-0';
      leaveFrom = 'translate-y-0';
      leaveTo = 'translate-y-full';
      break;
  }
});
</script>
